module.exports = __webpack_public_path__ + "img/no_company.ea12c265.png";